The product ID that was previously selected.

The selected product ID may be temporarily stored in a job ad draft.
When the hirer resumes their posting workflow from the draft at a later date,
this previous product ID should not be directly used to post the job ad.
Instead, pass the previous product ID in this field.
The query will then pre-select an equivalent ad product and return new product IDs that can be used to post the job ad.

Omit this field when you are newly creating or updating a job ad.
This is not the identifier of the job ad itself;
when you are updating a job ad,
supply the `positionProfile.profileId` instead.
